import React, { createContext, useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

type StringArray = string[] | []

interface RoutesHistory {
	history: StringArray;
}

const RoutesHistoryContext = createContext<RoutesHistory | undefined>(undefined);

export const useRoutesHistory = () => {
	return useContext(RoutesHistoryContext);
}

export const RoutesHistoryProvider: React.FC = ({ children }) => {
	const [history, setHistory] = useState<StringArray>([]);
	const routerHistory = useHistory();

	useEffect(() => {
		return routerHistory.listen((location) => {
			setHistory(prevHistory => [...prevHistory, location.pathname])
		})
	}, [routerHistory])

	return (
		<RoutesHistoryContext.Provider value={{
			history
		}}>
			{children}
		</RoutesHistoryContext.Provider>
	);
};
